import { Injectable } from '@angular/core';

import { AnalyticsBase } from '../lib/analytics-base';

@Injectable()
export class EventsAnalytics extends AnalyticsBase {
  public readonly namespace = 'Events';
  public readonly requireViewContext = true;

  public trackSchedule() {
    this.track('Schedule', {});
  }

  public trackCustomizeEmailForInterviewersClick() {
    this.track('CustomizeEmailForInterviewersClick', {});
  }

  public trackEventScheduled(props: {
    eventType: string;
    interviewers: number;
    isEvaluationRequested: boolean;
    isNotifyCandidateEnabled: boolean;
    isNotifyInterviewersEnabled: boolean;
    isEdit: boolean;
    isInviteCandidateViaCalendarEnabled: boolean;
    consecutiveEventNum: number;
  }) {
    this.track('EventScheduled', props, {
      integrations: { All: false, Mixpanel: true, Intercom: true },
    });
  }
}
